import React from 'react'
import { motion } from 'framer-motion'
import { Zap, Github, Globe } from 'lucide-react'

const Header = () => {
    return (
        <motion.header
            className="glass-effect border-b border-white/20"
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.8, type: "spring" }}
        >
            <div className="container mx-auto px-4 py-4">
                <div className="flex items-center justify-between">
                    <motion.div
                        className="flex items-center space-x-3"
                        whileHover={{ scale: 1.05 }}
                    >
                        <div className="w-10 h-10 bg-gradient-to-r from-primary to-secondary rounded-lg flex items-center justify-center">
                            <Zap className="w-6 h-6 text-white" />
                        </div>
                        <div>
                            <h1 className="text-2xl font-bold gradient-text">DeepNX</h1>
                            <p className="text-sm text-gray-600">AI Pipeline Generator</p>
                        </div>
                    </motion.div>

                    <div className="flex items-center space-x-4">
                        <motion.div
                            className="flex items-center space-x-2 text-sm text-gray-600"
                            whileHover={{ scale: 1.1 }}
                        >
                            <Globe className="w-4 h-4" />
                            <span>Live System</span>
                        </motion.div>

                        <motion.a
                            href="https://github.com/deepnx/pipeline"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-2 rounded-lg hover:bg-white/20 transition-colors"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <Github className="w-5 h-5 text-gray-600" />
                        </motion.a>
                    </div>
                </div>
            </div>
        </motion.header>
    )
}

export default Header